import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  failed: boolean
}

export class SceneBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('The WebGL archive could not be opened.', error, info)
  }

  render() {
    if (!this.state.failed) return this.props.children

    return (
      <div className="scene-fallback" role="img" aria-label="Abstract amber rings representing the ALMOST memory archive">
        <div className="fallback-orbit"><span /></div>
        <p>Your browser closed this branch of the archive.<br />The written journey remains open.</p>
      </div>
    )
  }
}
